import { useSpark } from "@/lib/store";
import { SparkSun } from "@/components/SparkSun";
import { SUN_RAYS, useSunRays } from "@/lib/sunRays";

// The user's own Sun: every ray is something they confirmed, never assumed.
export const PersonalSun = ({ compact = false }) => {
  const { profile, userId } = useSpark();
  const { earned, fresh, total } = useSunRays(profile, userId);
  const earnedRays = SUN_RAYS.filter(r => earned.includes(r.key));
  const remaining = total - earnedRays.length;

  return (
    <section data-testid="personal-sun-section" className={`grid gap-8 items-center ${compact ? "sm:grid-cols-[auto_1fr]" : "md:grid-cols-12"}`}>
      <div className={compact ? "" : "md:col-span-4 flex md:justify-start"}>
        <SparkSun size={compact ? 120 : 200} earned={earned} fresh={fresh} color="#C3A56B" strokeWidth={compact ? 1.1 : 0.9} title="Your Spark Sun" />
      </div>
      <div className={compact ? "" : "md:col-span-8"}>
        <p className="spark-eyebrow-copper spark-eyebrow-with-dot">Your Sun</p>
        <p className={`mt-3 spark-voice text-[#17171C] leading-snug ${compact ? "text-xl" : "text-2xl sm:text-3xl"}`}>
          {earnedRays.length === 0
            ? "Every ray of this mark will be something you've confirmed. Nothing assumed."
            : "Each ray here is something you've confirmed. Nothing was assumed."}
        </p>
        {earnedRays.length > 0 && (
          <ul data-testid="personal-sun-legend" className={`mt-5 grid gap-x-8 gap-y-2 text-sm text-[#56565D] ${compact ? "" : "sm:grid-cols-2"}`}>
            {earnedRays.map(r => (
              <li key={r.key} data-testid={`sun-ray-${r.key}`} className={`flex items-center gap-3 ${fresh.includes(r.key) ? "spark-ray-label-new" : ""}`}>
                <span className="h-px w-5 shrink-0" style={{ background: "#2C50A0" }} />
                {r.label}
              </li>
            ))}
          </ul>
        )}
        {remaining > 0 && (
          <p className="mt-4 text-xs text-[#8A8A91]">
            {remaining} more {remaining === 1 ? "ray" : "rays"} will be drawn as you confirm what Spark notices.
          </p>
        )}
      </div>
    </section>
  );
};

export default PersonalSun;
